export enum ESettingV2URL {
	HANDLE_BULK_PERMISSION_ACTIONS_URL = '/settingsV2/permissionsManagement/bulkPermission/bulkActions',
	EDIT_PERMISSION_URL = '/settingsV2/permissionsManagement/permission/edit',
	CREATE_PERMISSION_URL = '/settingsV2/permissionsManagement/permission/create',
	EDIT_PERMISSION_SET_URL = '/settingsV2/permissionsManagement/permissionSet/edit',
	CREATE_PERMISSION_SET_URL = '/settingsV2/permissionsManagement/permissionSet/create',
	CREATE_USER_URL = '/settingsV2/user/create',
	EDIT_USER_URL = '/settingsV2/user/edit'
}

export enum SERVICE_NAMES {
	AUTH = 'auth',
	USER = 'user',
	SUPERAPP = 'superapp',
	ADMIN = 'admin',
	PAYMENT = 'payment',
	KYC = 'kyc',
	WALLET = 'wallet',
	HELPDESK = 'helpdesk',
	DOORWAY = 'doorway',
	REWARD = 'reward',
	RECON = 'recon',
	THEMIS = 'themis',
	REFERRAL = 'referral'
}
